<template>
  <div>
    <Head :title="displayTitle" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-indigo-500 hover:text-indigo-800"
        :href="carouselPostsRoute"
      >
        Posty karuzeli
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ displayTitle }}
    </h1>
    <div class="w-full space-y-8">
      <div class="overflow-hidden rounded-sm bg-white shadow-sm">
        <carousel-post-form
          :form="form"
          :image-url="carousel_post.image_url"
          :site-context-options="site_context_options"
          @submit="submit"
        >
          <div
            class="flex items-center border-t border-gray-200 bg-gray-100 px-6 py-4"
          >
            <button
              class="btn-action-delete"
              type="button"
              title="Usuń"
              @click="destroy"
            >
              <icon name="trash" class="mr-1.5 h-3.5 w-3.5 stroke-current" />
              Usuń
            </button>
            <loading-button
              :loading="form.processing"
              class="btn-indigo ml-auto"
              type="submit"
            >
              Zapisz zmiany
            </loading-button>
          </div>
        </carousel-post-form>
      </div>

      <version-history :versions="versions" />
    </div>
  </div>
</template>

<script>
import { createLayoutHelper } from '@/utils/layoutHelper';

export default {
  layout: createLayoutHelper,
};
</script>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { Head, Link, router, useForm } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import VersionHistory from '@/Shared/VersionHistory.vue';
import CarouselPostForm from './Form.vue';
import { createCarouselPostRouteHelper } from '@/utils/createCarouselPostRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

const props = defineProps({
  // eslint-disable-next-line vue/prop-name-casing
  carousel_post: {
    type: Object,
    required: true,
  },
  // eslint-disable-next-line vue/prop-name-casing
  site_context_options: {
    type: Array,
    default: () => [],
  },
  versions: {
    type: Array,
    default: () => [],
  },
});

const emptyLocale = () => ({ title: '', description: '', button_text: '' });

const form = useForm({
  carousel_post: {
    data_pl: props.carousel_post.data_pl || emptyLocale(),
    data_en: props.carousel_post.data_en || emptyLocale(),
    site_context: props.carousel_post.site_context,
    button_url: props.carousel_post.button_url || '',
    button_link_label: props.carousel_post.button_link_label || '',
    button_link_type_label: props.carousel_post.button_link_type_label || '',
    show_button: props.carousel_post.show_button ?? true,
    active: props.carousel_post.active,
    image: null,
  },
});

const displayTitle = computed(() => form.carousel_post.data_pl?.title || 'Post karuzeli');

const carouselPostRoutes = computed(() => createCarouselPostRouteHelper(null, routes));

const carouselPostsRoute = computed(() => carouselPostRoutes.value.index());

const submit = () => {
  form.transform((data) => {
    const transformed = { ...data };
    if (transformed.carousel_post.image === null) {
      delete transformed.carousel_post.image;
    }
    return transformed;
  }).put(carouselPostRoutes.value.update(props.carousel_post.id));
};

const destroy = () => {
  if (confirm('Czy na pewno chcesz usunąć ten post karuzeli?')) {
    router.delete(carouselPostRoutes.value.destroy(props.carousel_post.id));
  }
};
</script>
